<template>
<x-y-chart
  v-if="dataList[0]"
  :data-config="dataList[0]"
  :unit-prop="unitProp"
  chart-type="bar"
  :stack-type="0"
  data-time-format="MM月DD日HH时"
  download-name="PM2.5和OCEC"
  chart-min-height="300px"
  chart-height="auto"
  style="height:100%;padding-top: 10px;"
/>
</template>

<script>
import BaseCompare from './BaseCompare'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'AuditOcEcDeviceCompareChart',
  extends: BaseCompare,
  components: {XYChart},
  props: {
    conditions: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    unitProp: 'stdUnit'
  }),
  computed: {
    completeAllData: () => true,
    otherSiteDeviceCategoryConfigs: () => [
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1008'))
    ]
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let siteId = dimensionIds[dimension]
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '1008') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        return {
          type: 'bar',
          stack: siteId,
          barMaxWidth: 30
        }
      }
    },
    getSelectedNames (dimension, params) {
      return dimension === 0 ? Object.values(params[dimension ^ 1]).reduce((map, config) => {
        map[config.name] = /^1008|640(0|1|4)$/.test(config.id)

        return map
      }, {}) : null
    }
  },
  watch: {
    filterFactorMap: {
      immediate: true,
      handler (filterFactorMap) {
        this.selectedNames = this.query.factorIds.reduce((list, factorId) => {
          if (/^1008|640(0|1|4)$/.test(factorId)) {
            let factor = filterFactorMap[factorId]

            if (factor) {
              list.push(factor.name)
            }
          }

          return list
        }, [])
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditOcEcDeviceCompareChart.vue